import { render } from "./ChildTweetMsg.vue?vue&type=template&id=71343dbe&scoped=true"
import script from "./ChildTweetMsg.vue?vue&type=script&lang=js"
export * from "./ChildTweetMsg.vue?vue&type=script&lang=js"

import "./ChildTweetMsg.vue?vue&type=style&index=0&id=71343dbe&lang=scss&scoped=true"

import exportComponent from "/Users/parasagrawal/projects/twitter-helpdesk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71343dbe"]])

export default __exports__